<template>
  <div class="plugin-wrapper" v-if="config.nodes">
    <div class="layout plugin-multi_image_product" :data-size="config.nodes.length">
      <div class="ms-row m-text-images" style="">
        <div v-for="(node, index) in config.nodes" :key="index"
          :class="[`col-xs-6`, `col-md-${12/(config.nodes.length>4?4:config.nodes.length)}`, `center-xs` ]"
        >
          <a class="image-text" @click="actionHandler(node.action)">
            <div class="image-container">
              <img class="image__item--hover image__visual--hover lazyloaded" :src="node.src.hover" :alt="node.title" />
              <img class="image__item image__visual lazyloaded" :src="node.src.active" :alt="node.title" />
            </div>
            <div class="image__title"><h5 class="text--uppercase">{{node.title}}</h5></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actionMixins from '@/utils/action.mixins';

export default {
  name: "MultiImageProductHigh",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  created() {
    if (this.config?.nodes?.length > 4) {
      console.info("列表项太多，建议3~4个");
    }
  },
  methods: {},
  computed: {
    isMaster() {
      return this.$store.state.isMaster;
    }
  }
}
</script>

<style lang="scss" scoped>
  .plugin-wrapper {
    .plugin-multi_image_product {
      padding: 0 1.0625rem 0; border-bottom: .0625rem solid #dfdfdf; border-top: .0625rem solid #dfdfdf;
      .m-text-images { padding: 2.875rem 0 .6875rem; }
      .image-text {
        display: block; text-decoration: none; margin-bottom: 1.75rem;
        .image-container {
          position: relative;
          & > * { display: block; }
          .image__item--hover { display: none; }
          .image__visual, .image__visual--hover { width: 100%; }
          &::after { content: ""; display: block; height: 0; width: 100%; }
        }
        .image__title {
          margin-top: .6875rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; text-transform: none;
          h5.text--uppercase { font-size: 0.875rem; }
        }
      }
    }
  }
  @media screen and (min-width: 48em) {
    .plugin-wrapper {
      .plugin-multi_image_product {
        padding: 0 3.875rem 0;
        .m-text-images { padding: 4rem 0 1.125rem; }
        .image-text {
          margin-bottom: 2.3125rem;
          .image__title { margin-top: 1.0625rem; }
        }
      }
    }
  }
  @media screen and (min-width: 64em) {
    .plugin-wrapper {
      .plugin-multi_image_product {
        padding: 0 1.875rem 0;
        .image-text {
          .image-container {
            overflow: hidden;
            & > * {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
            // 去掉两张图的透明度过渡效果，改为缩放效果
            // .image__item--hover { display: block; }
            .image__visual { opacity: 1; transition: opacity .5s ease-in-out, transform 0.3s; max-width: 100%; }
            .image__visual--hover { opacity: 0; transition: opacity .5s ease-in-out; }
            &::after { padding-bottom: 69.69%; }
            &:hover {
              // .image__visual { opacity: 0; }
              // .image__visual--hover { opacity: 1; }
              .image__visual { transform: scale(1.2); }
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-wrapper {
      .plugin-multi_image_product {
        padding: 0;
      }
    }
  }
</style>